import {HeartHandshake} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'residents',
    children: [
      {
        path: '',
        loader: protectedLoader('RESIDENTS', 'VIEW_RESIDENTS'),
        async lazy() {
          const {ResidentListPage} = await import('./pages/ResidentListPage');
          return {element: <ResidentListPage />};
        },
        children: [
          {
            path: 'add',
            async lazy() {
              const {AddResidentPage} = await import('./pages/AddResidentPage');
              return {element: <AddResidentPage />};
            },
          },
        ],
      },
      {
        path: 'pending',
        loader: protectedLoader('RESIDENTS', 'VIEW_RESIDENTS'),
        async lazy() {
          const {ResidentPendingListPage} = await import(
            './pages/ResidentPendingListPage'
          );
          return {element: <ResidentPendingListPage />};
        },
      },
      {
        path: 'old',
        loader: protectedLoader('RESIDENTS', 'VIEW_OLD_RESIDENTS'),
        async lazy() {
          const {ResidentOldListPage} = await import(
            './pages/ResidentOldListPage'
          );
          return {element: <ResidentOldListPage />};
        },
      },
      {
        path: ':id',
        loader: protectedLoader('RESIDENTS', 'VIEW_RESIDENT'),
        async lazy() {
          const {EditResidentPage} = await import('./pages/EditResidentPage');
          return {element: <EditResidentPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/residents',
    text: i18n.t('Residents'),
    icon: <HeartHandshake />,
    permission: 'VIEW_RESIDENTS',
    entitlement: 'RESIDENTS',
  },
] as MenuItemElement[];
